import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CopiedMessageComponent } from '../../../../../shared/copied-message/copied-message.component';

@Component({
    selector: 'rn-apikey-item',
    templateUrl: './apikey-item.component.html',
    styleUrls: ['./apikey-item.component.scss'],
    standalone: true,
    imports: [MatTooltipModule, CopiedMessageComponent]
})
export class ApikeyItemComponent {
  isHidden: boolean = true;
  showCopyMsg: boolean = false;
  @Input() text: string;
  @Input() canDelete: boolean = false;
  @Output() delete: EventEmitter<string> = new EventEmitter<string>();

  getObscuredText(): string {
    return this.isHidden ? `${this.text.slice(0, 4)}************************************` : this.text;
  }

  get matTooltipText(): string {
    return this.isHidden ? 'Show' : 'Hide';
  }

  handleToggle(value = !this.isHidden) {
    this.isHidden = value;
  }

  handleDelete() {
    this.delete.emit(this.text);
  }
}
